import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import MeetingRoomOutlinedIcon from '@mui/icons-material/MeetingRoomOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { shortTime } from './dayRooms';
import styles from './DayRoomChip.module.css';

/**
 * Chip "Sala X" de uma agenda num dia. Abre o popup de sala do dia ao clicar.
 * `summary` vem de summarizeDayRooms; `compact` é a versão do cabeçalho da coluna;
 * `readOnly` só mostra a sala (coluna da agenda), sem clique.
 */
function DayRoomChip({ summary, onClick, compact = false, disabled = false, readOnly = false }) {
  const hasRoom = !!summary.roomId;
  const marker = summary.fromTime
    ? `a partir das ${summary.fromTime}`
    : summary.source === 'default' ? 'sala padrão da agenda' : '';
  const roomText = `${summary.roomLabel}${marker ? ` (${marker})` : ''}`;
  const tooltip = hasRoom
    ? `${roomText}. Clique para trocar a sala deste dia.`
    : 'Sem sala neste dia. Clique para definir.';

  if (readOnly) {
    return (
      <Tooltip title={roomText} arrow placement="bottom" enterDelay={400} enterTouchDelay={0} leaveTouchDelay={2500}>
        <span className={`${styles.chip} ${styles.readOnly} ${compact ? styles.compact : ''}`}>
          <MeetingRoomOutlinedIcon className={styles.icon} />
          <span className={styles.label}>{summary.roomLabel}</span>
          {summary.fromTime && (
            <span className={styles.marker}>{compact ? shortTime(summary.fromTime) : `a partir das ${summary.fromTime}`}</span>
          )}
        </span>
      </Tooltip>
    );
  }

  const content = (
    <button
      type="button"
      className={`${styles.chip} ${compact ? styles.compact : ''} ${hasRoom ? '' : styles.empty} ${disabled ? styles.disabled : ''}`}
      onClick={(e) => { e.stopPropagation(); if (!disabled && onClick) onClick(); }}
      disabled={disabled}
    >
      <MeetingRoomOutlinedIcon className={styles.icon} />
      <span className={styles.label}>{hasRoom ? summary.roomLabel : 'Definir sala'}</span>
      {hasRoom && summary.fromTime && (
        <span className={styles.marker}>{compact ? shortTime(summary.fromTime) : `a partir das ${summary.fromTime}`}</span>
      )}
      {hasRoom && !summary.fromTime && summary.source === 'default' && !compact && (
        <span className={styles.marker}>padrão</span>
      )}
      {!disabled && <KeyboardArrowDownIcon className={styles.arrow} />}
    </button>
  );

  return (
    <Tooltip title={tooltip} arrow placement="bottom" enterDelay={400} enterTouchDelay={0} leaveTouchDelay={2500}>
      {content}
    </Tooltip>
  );
}

export default DayRoomChip;
